import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TIntegrationType } from '@gen2/api/integrations/api';
import { useSyncFoldersMutation } from '@gen2/api/integrations/hooks';
import { useToast } from '@gen2/hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { ModalCloseButton } from '@nx-fe/components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useIntegrationsStore } from '../store';
import { StyledContent, StyledDialog } from './resync-modal.styled';

const ResyncModal = () => {
  const { t } = useTranslation('integrations');
  const { isResyncOpen, cancelResync, confirmResync } = useIntegrationsStore();
  const { mutate: syncFoldersMutation } = useSyncFoldersMutation();
  const { vendor } = useParams<{ vendor: TIntegrationType }>();
  const toast = useToast();
  const handleResync = () => {
    syncFoldersMutation(
      { vendor: vendor || 'google' },
      {
        onSuccess: (data) => {
          confirmResync();
          toast.show({
            text: data.data.message ?? t(`resync.success_sync`),
            variant: 'success',
          });
        },
        onError: () => {
          toast.show({
            text: t(`resync.error_sync`),
            variant: 'error',
          });
        },
      },
    );
  };

  return (
    <StyledDialog
      open={isResyncOpen}
      onClose={cancelResync}
      aria-labelledby="resync"
      aria-describedby="resync"
      data-cy="resync"
    >
      <ModalCloseButton
        data-cy="resync-close"
        aria-label="close"
        onClick={cancelResync}
      >
        <FontAwesomeIcon icon={faXmark} />
      </ModalCloseButton>
      <DialogTitle id="alert-dialog-title">{t('resync.title')}</DialogTitle>
      <DialogContent dividers>
        <StyledContent>{t('resync.message')}</StyledContent>
      </DialogContent>
      <DialogActions>
        <Button
          data-cy="resync-cancel"
          onClick={cancelResync}
          color="tertiary"
          variant="outlined"
        >
          {t('resync.cancel_btn')}
        </Button>
        <Button
          data-cy="resync-btn"
          onClick={handleResync}
          color="primary"
          variant="contained"
        >
          {t('resync.confirm_btn')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ResyncModal;
